import { render, staticRenderFns } from "./EditRuche.vue?vue&type=template&id=08bcc49d&"
import script from "./EditRuche.vue?vue&type=script&lang=js&"
export * from "./EditRuche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports